var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountry9(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 124,
    viewBox: "0 0 131 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_344_534",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 131,
    height: 124
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130.658,
    height: 124,
    rx: 33,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129.658,
    height: 123,
    rx: 32.5,
    stroke: "#1E417C",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_344_534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H130.658V130.658H0V0Z",
    fill: "#000066"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0094 94.0633L24.3702 97.9932L27.7897 87.4283L31.1837 97.9932L41.57 94.0633L35.4199 103.327L44.9641 108.992L33.9143 109.936L35.4454 120.935L27.7897 112.896L20.134 120.935L21.6651 109.962L10.5898 108.992L20.1595 103.327L14.0094 94.0633ZM103.097 121.573L98.2479 121.981L98.9369 126.779L95.6194 123.283L92.302 126.779L92.8889 121.981L88.0913 121.573L92.2509 119.123L89.5714 115.091L94.0883 116.801L95.5684 112.207L97.023 116.801L101.565 115.091L98.9114 119.123L103.097 121.573ZM103.045 50.1194L98.2479 50.5277L98.9114 55.3253L95.5939 51.8292L92.2764 55.3253L92.8889 50.5277L88.0913 50.1194L92.2509 47.6696L89.5714 43.6376L94.0883 45.3473L95.5684 40.7539L97.023 45.3473L101.565 43.6376L98.9114 47.6696L103.045 50.1194ZM76.2504 79.1601L71.4529 79.5684L72.1164 84.3405L68.7989 80.8444L65.4814 84.3405L66.1194 79.5684L61.3218 79.1601L65.4814 76.6848L62.8019 72.6783L67.3188 74.3881L68.7989 69.7946L70.2535 74.3881L74.7703 72.6783L72.1164 76.6848L76.2504 79.1601ZM126.829 72.0148L122.032 72.4231L122.695 77.1952L119.378 73.699L116.06 77.1952L116.698 72.4231L111.901 72.0148L116.06 69.5394L113.381 65.5329L117.898 67.2427L119.378 62.6493L120.858 67.2427L125.349 65.5329L122.695 69.5394L126.829 72.0148ZM106.312 90.5927L103.683 92.2259L104.424 89.2146L102.05 87.2242L105.113 86.9945L106.312 84.1364L107.435 87.02L110.523 87.2752L108.175 89.2402L108.915 92.2514",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H65.3289V65.3289H0V0Z",
    fill: "#000066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3289 0V8.16611L41.0857 32.6644L65.3289 56.5248V65.3289H56.78L32.4092 41.3409L8.67649 65.3289H0V56.6524L23.7327 32.792L0 9.44206V0H7.91092L32.4092 23.9879L56.142 0H65.3289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4776 41.3409L24.8811 45.6792L5.35901 65.3289H0V64.9461L23.4776 41.3409ZM39.2994 39.8098L46.1895 40.8305L65.3289 59.5871V65.3289L39.2994 39.8098ZM65.3289 0L40.8305 25.0087L40.3202 19.3945L59.4595 0H65.3289ZM0 0.127595L24.6259 24.2431L17.0978 23.2224L0 6.25218V0.127595Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4568 0V65.3289H42.8721V0H22.4568ZM0 22.4568V42.8721H65.3289V22.4568H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.5398V38.789H65.3289V26.5398H0ZM26.5398 0V65.3289H38.789V0H26.5398Z",
    fill: "#C8102E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry9);
export default __webpack_public_path__ + "static/media/country9.170c510e9adb7c73369fbc548579575c.svg";
export { ForwardRef as ReactComponent };